import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

export interface PackingTabExtraContextValue {
  tabExtra: ReactNode;
  setTabExtra: (node: ReactNode) => void;
}

export const PackingTabExtraContext = createContext<PackingTabExtraContextValue>({
  tabExtra: null,
  setTabExtra: () => {},
});

export function PackingTabExtraProvider({ children }: { children: ReactNode }) {
  const [tabExtra, setTabExtra] = useState<ReactNode>(null);

  return (
    <PackingTabExtraContext.Provider value={{ tabExtra, setTabExtra }}>
      {children}
    </PackingTabExtraContext.Provider>
  );
}

type TabExtraContent = ReactNode | (() => ReactNode);

/** Register toolbar content shown to the right of packing route tabs. */
export function usePackingTabExtraContent(content: TabExtraContent, deps: unknown[]) {
  const { setTabExtra } = useContext(PackingTabExtraContext);

  useEffect(() => {
    setTabExtra(typeof content === 'function' ? content() : content);
    return () => setTabExtra(null);
  }, deps);
}
